import React, { useMemo, useState , useEffect } from 'react';
import TableContainer from "../../../Components/Common/TableContainerReactTable";
import { Button, Card, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { Run_Fav_Prompt_SQL } from '../../../slices/thunks';
import { useSelector } from 'react-redux';
import Loader from '../Loader';
import * as XLSX from 'xlsx';
import { set_fav_prompt_sql_result } from '../../../slices/Favourite_Prompt/reducer';

function Sql_Preview_modal({Bot_Favorite_Prompt_ID ,Description , database_id , sql_query }) {
  const [modal_center, setmodal_center] = useState(false);
  const [data_headers, setdata_headers] = useState([])

  
  const dispatch = useDispatch()
  const { Fav_Prompt_SQL_Result , Fav_Prompt_SQL_Result_Loader } = useSelector((state)=>state.Favourite_Prompt)
  
  
  useEffect(() => {
    
    if(modal_center){
      dispatch(Run_Fav_Prompt_SQL({
        database_id,
        sql_query
      }))
    }


 
  }, [modal_center])


  useEffect(() => {

    let Column_Headers = Object.keys(Fav_Prompt_SQL_Result[0] || {}) || [] 
  
    Column_Headers = Column_Headers.map((ele)=>{
      return {
          header: ele,
          accessorKey: ele,
          enableColumnFilter: false,
        }
      })


      setdata_headers(Column_Headers)
    
  }, [Fav_Prompt_SQL_Result])
  
  
  
  
  const searchTable =Fav_Prompt_SQL_Result 
  

    
   const downloadExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(Fav_Prompt_SQL_Result);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "DataSheet.xlsx");
    };
     
    const columns = useMemo(
      () => data_headers,
      []
    );



  // const columns = useMemo(
  //   () => [
  //     {
  //       header: "ID",
  //       cell: (cell) => {
  //         return (
  //           <span className="fw-semibold">{cell.getValue()}</span>
  //         );
  //       },
  //       accessorKey: "id",
  //       enableColumnFilter: false,
  //     },

  //     {
  //       header: "Name",
  //       accessorKey: "name",
  //       enableColumnFilter: false,
  //     },
  //     {
  //       header: "Email",
  //       accessorKey: "email",
  //       enableColumnFilter: false,
  //     },
  //     {
  //       header: "Designation",
  //       accessorKey: "designation",
  //       enableColumnFilter: false,
  //     },
  //     {
  //       header: "Company",
  //       accessorKey: "company",
  //       enableColumnFilter: false,
  //     },
  //     {
  //       header: "Location",
  //       accessorKey: "location",
  //       enableColumnFilter: false,
  //     }
  //   ],
  //   []
  // );
  
  function tog_center() {
    setmodal_center(!modal_center);
    dispatch(set_fav_prompt_sql_result({result:[]}))
  }
  return (
    
    
    


    
    <React.Fragment >
        <Button color="primary" onClick={() => tog_center()}>SQL</Button>
        {/* Vertically Centered */}
        <Modal
                size="xxl"
                isOpen={modal_center}
                toggle={() => {
                    tog_center();
                }}
                centered
                className='pd_sql'
            >
                
                <ModalHeader className="modal-title cust-work"
                    id="myModalLabel" toggle={() => {
                        tog_center();
                    }}>

                  <Button onClick={downloadExcel} color="primary">Download as Excel</Button> 
                  <span className='prompt_title' style={{fontSize:'20px'}}>{Description}</span>                 
                </ModalHeader>
                
                 
                <ModalBody className="">
                    <div className='sql_wrap'>
                {Fav_Prompt_SQL_Result_Loader?<Loader/>:<TableContainer
                    columns={(data_headers || [])}
                    data={Fav_Prompt_SQL_Result || []}
                    isGlobalFilter={false}
                    customPageSize={Fav_Prompt_SQL_Result.length > 5 ? 10 : Fav_Prompt_SQL_Result.length }
                    SearchPlaceholder='Search...'
                />}
                </div>
                </ModalBody>
            </Modal>


      
    </React.Fragment >
  );
}

export default Sql_Preview_modal